import { IXMLHttpConfig } from "./types";

export class XMLHttpConfig implements IXMLHttpConfig {    
    public Url: string;
    public Params: string | any;
    public Headers: string | any;

    constructor(url: string, params?: [string, any], headers?: [string, any]) {
        this.Url = url;
        this.Params = params;
        this.Headers = headers;
    }
} 



// WEBPACK FOOTER //
// ./src/global/XMLHttpConfig.ts